<div class="tab-wrapper" [ngClass]="{ mobile: (isMobile$ | async) }">
  <div class="dashboard-card d-card-padding">
    <app-withdraw></app-withdraw>
  </div>

  <ng-container *ngIf="initPayoutsLoaded === true; else initPayoutsLoading">
    <div class="dashboard-card d-card-padding">
      <ng-container *ngIf="initPayouts?.count !== 0; else emptyPayouts">
        <div class="history-header">
          <div class="left">
            <h4 class="bold">{{ 'WM_TECH_POOL.PAYOUTS.HISTORY' | translate }}</h4>
          </div>
          <div class="right" [formGroup]="filtersForm">
            <mat-form-field>
              <mat-label>{{ 'WM_TECH_POOL.DATE.ENTIRE_PERIOD' | translate }}</mat-label>
              <mat-date-range-input [rangePicker]="picker" panelClass="form-select">
                <input matStartDate [placeholder]="'FILTERS.START_TIME' | translate" formControlName="startTime" />
                <input matEndDate [placeholder]="'FILTERS.END_TIME' | translate" formControlName="endTime" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="payoutsLoaded === true; else payoutsLoading">
          <app-data-table
            *ngIf="payouts"
            [title]="'payouts'"
            [sorting]="false"
            [dataSource]="payouts.data"
            [displayedColumns]="displayedColumns"
            [countData]="payouts.count"
            [pageIndex]="page / count"
            [count]="count"
            (pageChange)="pageChange($event)"
            (cancelPayout)="cancelPayout($event)"
          ></app-data-table>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #initPayoutsLoading>
  <div class="dashboard-card wm-loading" style="height: 50vh"></div>
</ng-template>

<ng-template #payoutsLoading>
  <div class="dashboard-card wm-loading" style="height: 30vh"></div>
</ng-template>

<ng-template #emptyPayouts>
  <app-empty-data [data]="'payouts'"></app-empty-data>
</ng-template>
